import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Text, Icon } from 'components/ui';
import { colors, space } from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import Actions from 'Actions';
import { renderModal, globalModals } from 'utils/globalModals';
import { globalModalsSelector } from 'selectors/page/headerFooterTemplate/data/globalModals/globalModalsSelector';
import bccUtils from 'utils/BCC';
import languageLocale from 'utils/LanguageLocale';
import FulfillmentMethodsEN from 'components/ProductPage/FulfillmentMethods/locales/FulfillmentMethods_en_US';
import FulfillmentMethodsFR from 'components/ProductPage/FulfillmentMethods/locales/FulfillmentMethods_fr_CA';

const { SHIPPING_AND_HANDLING_INFO } = globalModals;
const { US_SHIPPING_INFO, CA_SHIPPING_INFO } = bccUtils.MEDIA_IDS;
const getText = languageLocale.getLocalisedDataFromResource(FulfillmentMethodsEN, FulfillmentMethodsFR);

const styles = {
    infoButton: {
        appearance: 'none',
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        padding: space[1],
        margin: -space[1],
        display: 'inline-flex',
        alignItems: 'center',
        color: colors.gray
    }
};

const FreeReturnsBanner = () => {
    const dispatch = useDispatch();
    const globalModalsData = useSelector(globalModalsSelector);
    const shippingAndHandlingModal = globalModalsData[SHIPPING_AND_HANDLING_INFO];

    const handleInfoClick = useCallback(
        e => {
            e?.preventDefault();
            e?.stopPropagation();
            renderModal(shippingAndHandlingModal, () => {
                dispatch(
                    Actions.showMediaModal({
                        isOpen: true,
                        mediaId: languageLocale.isCanada() ? CA_SHIPPING_INFO : US_SHIPPING_INFO,
                        titleDataAt: 'shippingHandlingModalTitle'
                    })
                );
            });
        },
        [dispatch, shippingAndHandlingModal]
    );

    return (
        <Flex
            alignItems='center'
            gap={2}
            width='100%'
        >
            <Icon
                name='returns30Day'
                size={20}
                viewBox='0 0 20 20'
            />
            <Flex
                alignItems='center'
                gap='2px'
            >
                <Text
                    is='p'
                    fontSize='base'
                    color='black'
                    lineHeight='tight'
                >
                    <Text
                        is='span'
                        fontWeight='bold'
                        children={getText('freeReturnsBannerPrefix')}
                    />
                    {getText('freeReturnsBannerSuffix')}
                </Text>
                <button
                    type='button'
                    onClick={handleInfoClick}
                    aria-label={getText('freeReturnsInfoAriaLabel')}
                    css={styles.infoButton}
                >
                    <Icon
                        name='infoOutline'
                        size={16}
                    />
                </button>
            </Flex>
        </Flex>
    );
};

export default wrapFunctionalComponent(FreeReturnsBanner, 'FreeReturnsBanner');
